<wbo-edit-page #editPage [title]="model.data.name" (saved)="saved($event)" (addingAnother)="addingAnother($event)">
    <fui-formation-group-template *formationGroup="{title: 'wbo.outlet.edit.formation.details', formControlNames: ''}">
        <fui-rows [formGroup]="editPage.formGroup">
            <fui-row>
                <fui-four-columns>
                    <fui-column>
                        <wbo-text-edit-control formControlName="name" [(ngModel)]="model.data.name"></wbo-text-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-text-edit-control [readonly]="true" formControlName="outletId"
                                               [(ngModel)]="model.data.outletId"></wbo-text-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-text-edit-control formControlName="storeName"
                                               [(ngModel)]="model.data.storeName"></wbo-text-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-text-edit-control formControlName="exportCode"
                                               [(ngModel)]="model.data.exportCode"></wbo-text-edit-control>
                    </fui-column>
                </fui-four-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-location-single-select-edit-control formControlName="outletGroupId"
                                                                 [(ngModel)]="model.data.outletGroupId"
                                                                 [readonly]="fixedOutletGroupId">
                        </wbo-location-single-select-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-company-details-single-select-edit-control formControlName="companyDetailsId"
                                                                        [(ngModel)]="model.data.companyDetailsId"
                                                                        [objectValue]="model.data.companyDetails"
                                                                        (onClear)="clearCompanyDetails()"></wbo-company-details-single-select-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-checkbox-edit-control formControlName="allowStockOrder"
                                                   [(ngModel)]="model.data.allowStockOrder"></wbo-checkbox-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column [label]="'wbo.outlet.edit.field-set.pickupAddress'">
                        <wbo-checkbox-edit-control formControlName="useCompanyAddressForPickup"
                                                   [(ngModel)]="model.data.useCompanyAddressForPickup"
                                                   [readonly]="model.data.companyDetailsId == undefined"></wbo-checkbox-edit-control>
                        <wbo-address-edit [showCountry]="false" [readonly]="model.data.useCompanyAddressForPickup"
                                          [formGroupAddress]="editPage.formGroup.controls['pickupAddress']"
                                          [address]="pickupAddress"></wbo-address-edit>
                        <fui-tandem-field>
                            <wbo-text-edit-control [readonly]="model.data.useCompanyAddressForPickup"
                                                   formControlName="pickupTelephone"
                                                   [(ngModel)]="pickupTelephone"></wbo-text-edit-control>
                        </fui-tandem-field>
                    </fui-column>
                    <fui-column [label]="'wbo.outlet.edit.field-set.deliveryAddress'">
                        <wbo-checkbox-edit-control formControlName="useCompanyAddressForDelivery"
                                                   [(ngModel)]="model.data.useCompanyAddressForDelivery"
                                                   [readonly]="model.data.companyDetailsId == undefined"></wbo-checkbox-edit-control>
                        <wbo-address-edit [showCountry]="false" [readonly]="model.data.useCompanyAddressForDelivery"
                                          [formGroupAddress]="editPage.formGroup.controls['deliveryAddress']"
                                          [address]="deliveryAddress"></wbo-address-edit>
                        <fui-tandem-field>
                            <wbo-text-edit-control [readonly]="model.data.useCompanyAddressForDelivery"
                                                   formControlName="deliveryTelephone"
                                                   [(ngModel)]="deliveryTelephone"></wbo-text-edit-control>
                        </fui-tandem-field>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <fui-tandem-field>
                            <wbo-numeric-edit-control formControlName="latitude"
                                                      [(ngModel)]="model.data.latitude"></wbo-numeric-edit-control>
                            <wbo-numeric-edit-control formControlName="longitude"
                                                      [(ngModel)]="model.data.longitude"></wbo-numeric-edit-control>
                        </fui-tandem-field>
                    </fui-column>
                    <fui-column>
                        <wbo-time-zone-single-select-edit-control formControlName="timeZone"
                                                                  [(ngModel)]="model.data.timeZone"></wbo-time-zone-single-select-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column formGroupName="ordersPreparationResourceType">
                        <wbo-preparation-resource-type-single-select-edit-control [(ngModel)]="model.data.ordersPreparationResourceType.id"
                                                                                  [objectValue]="model.data.ordersPreparationResourceType"
                                                                                  formControlName="id">
                        </wbo-preparation-resource-type-single-select-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-single-select-edit-control formControlName="smsNameType"
                                                        [(ngModel)]="model.data.smsNameType"
                                                        [allowClearSelectionOption]="false">
                            <wbo-select-options>
                                <wbo-select-option [value]="OutletExternalNameType.WEB_TERMINAL_STORE_NAME"
                                                   label="wbo.outlet.edit.option.sms-name-type.web-terminal-store-name"></wbo-select-option>
                                <wbo-select-option [value]="OutletExternalNameType.OUTLET_STORE_NAME"
                                                   label="wbo.outlet.edit.option.sms-name-type.outlet-store-name"></wbo-select-option>
                                <wbo-select-option [value]="OutletExternalNameType.LOCATION_NAME"
                                                   label="wbo.outlet.edit.option.sms-name-type.location-name"></wbo-select-option>
                                <wbo-select-option [value]="OutletExternalNameType.COMPANY_NAME"
                                                   label="wbo.outlet.edit.option.sms-name-type.company-name"></wbo-select-option>
                            </wbo-select-options>
                        </wbo-single-select-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-textarea-edit-control formControlName="description"
                                                   [(ngModel)]="model.data.description"></wbo-textarea-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-text-edit-control formControlName="billableCode"
                                               [(ngModel)]="model.data.billableCode"></wbo-text-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
    <fui-formation-group-template *formationGroup="{title: 'wbo.outlet.edit.formation.salePeriods', formControlNames: 'outletSalePeriods'}">
        <wbo-outlet-edit-sale-periods></wbo-outlet-edit-sale-periods>
    </fui-formation-group-template>
    <fui-formation-group-template *formationGroup="{title: 'wbo.outlet.edit.formation.customOutletGroups', formControlNames: 'customObjectContext'}">
        <fui-rows [formGroup]="editPage.formGroup">
            <fui-row>
                <fui-two-columns>
                    <fui-column formGroupName="customObjectContext">
                        <wbo-custom-object-multi-select-edit-control formControlName="customObjects" [outletContext]="true"
                                                                     [(ngModel)]="model.data.customObjectContext.customObjects">
                        </wbo-custom-object-multi-select-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
</wbo-edit-page>
